import React from 'react';
import cn from 'classnames';

export default function Button({ className, ...rest }) {
  const styles = cn('btn', className);
  return <button className={styles} {...rest} />;
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/Button/Button.js